// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"372":"32fc5ebe0c09b6e80efe","547":"e1e9d2d4f9dbfcd3943b","926":"d0d3c57d9dbedd989fd5"}[chunkId] + ".chunk.js";
};